import React, { useState } from "react";
import axios from "axios";
import "../community.css";
import "../ai.css";
import { useParams, Link } from "react-router-dom";
import { updateDoc, doc, increment } from "firebase/firestore";
import { auth, db } from "../../firebase";


/* ==========================================================
   Interview Coach Tool
   ========================================================== */

function InterviewCoach() {
  const [question, setQuestion] = useState("");
  const [coach, setCoach] = useState("");
  const [loading, setLoading] = useState(false);

  const apiBase = process.env.REACT_APP_API_URL;
  const MAX_CHARS = 5000;

  /* ==========================================================
     Validate & Submit Interview Question
     ========================================================== */
  const askCoach = async () => {
    if (!question.trim()) {
      alert("Please enter an interview question or HR topic.");
      return;
    }

    if (question.length > MAX_CHARS) {
      alert("Your question is too long. Try shortening it for better results.");
      return;
    }

    setLoading(true);
    setCoach("");

    try {
      const res = await axios.post(`${apiBase}/api/ai-interview-coach`, {
        question,
      });

      setCoach(res.data.coach);
    } catch (err) {
      console.error("Interview coach error:", err);
      setCoach("Error generating interview guidance. Please try again.");
    }

    try {

  const user = auth.currentUser;

  if (user) {
    await updateDoc(doc(db, "users", user.uid), {
      "progress.interviews": increment(1)
    });
  }

} catch (err) {
  console.error("Interview progress update failed:", err);
}

    setLoading(false);
  };

  /* ==========================================================
     UI
     ========================================================== */

  return (
    <div className="ai-tool-wrapper">
      <Link to="/community">
  <button className="back-btn">← Back to Community</button>
</Link>
      <h2 className="ai-tool-title">🎙 Interview Coach</h2>

      {/* QUESTION INPUT */}
      <textarea
        className="ai-input"
        placeholder="Ask an interview question... (e.g. 'How do I answer: Tell me about yourself?')"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        maxLength={MAX_CHARS}
      ></textarea>

      {/* CHARACTER COUNTER */}
      <div className="char-counter">
        {question.length} / {MAX_CHARS}
      </div>

      {/* SUBMIT BUTTON */}
      <button className="ai-btn" onClick={askCoach} disabled={loading}>
        {loading ? "Thinking..." : "Get Coaching Advice"}
      </button>

      {/* OUTPUT */}
      {coach && (
        <div className="ai-output">
          <h3 className="ai-output-title">Response</h3>
          <pre className="ai-output-box">{coach}</pre>
        </div>
      )}
    </div>
  );
}

export default InterviewCoach;

